import { render, staticRenderFns } from "./FormsQueue.vue?vue&type=template&id=46356204&scoped=true"
import script from "./FormsQueue.vue?vue&type=script&lang=js"
export * from "./FormsQueue.vue?vue&type=script&lang=js"
import style0 from "./FormsQueue.vue?vue&type=style&index=0&id=46356204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46356204",
  null
  
)

export default component.exports